"use client"

import type React from "react"

interface DeleteModalProps {
  onClose: () => void
  onConfirm: () => void
  message: string
}

const DeleteModal: React.FC<DeleteModalProps> = ({ onClose, onConfirm, message }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm z-50">
      <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-xl max-w-md w-full mx-4 border">
        <div className="flex items-center gap-3 mb-4">
          <div className="flex-shrink-0">
            <span className="text-red-600 dark:text-red-400 text-xl">⚠️</span>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Confirm Deletion</h3>
        </div>

        <p className="text-gray-600 dark:text-gray-300 mb-6 leading-relaxed">{message}</p>

        <div className="flex gap-3 justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors font-medium"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded-md bg-red-600 text-white hover:bg-red-700 transition-colors font-medium"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  )
}

export default DeleteModal
